module.exports = __webpack_public_path__ + "static/media/pay-visa-off.8945e666.png";